<template>
  <mymodal ref="theModal" :need-header="true" :need-footer="false" :size="'medium'">
    <div slot="title">{{getTitleText}}</div>
    <div slot="body">
        <form-purchase
        ref="purchase_form"
        :from_buyers="from_buyers"
        @updatePurchase="updatePurchase"
      ></form-purchase>
    </div>
  </mymodal>
</template>
<script>
import mymodal from "@/components/elements/Modal";
import Utils from "@/helpers/utils";
import FormPurchase from "@/components/Purchase/FormPurchase";
import Loading from "@/components/elements/Loading";
//import GoogleAutocomplete from 'google-autocomplete-vue';
export default {
  name: "FormSubUser",
  components: {
    mymodal,
    Loading,
    FormPurchase
  },
  props: ["pass_data", "from_buyers"],
  computed: {
   
    getTitleText() {
      if (this.item.id) {
        return this.item.status == 0 ? this.$t("Update purchase") : this.$t("View purchase");
      } else {
        return this.$t("Add purchase");
      }
    }
  },
  data() {
    
    return {
    
      item: {}
    };
  },
  created() {
    // clone from original params
  },

  methods: {
    open() {
      this.$refs.theModal.open();
      this.$refs.purchase_form.updateData(this.pass_data);
    },
    updatePurchase(data) {
      console.log('data22',data);
      if (!isNaN(data)){
        this.$router.push({ name: "PurchaseDetail", params: {id:data} });
      }else{
        this.$refs.theModal.close();
        this.$emit("modalData", {});
      }

    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Purchase/FormPurchaseModal.vue